import { render, staticRenderFns } from "./TechKit.vue?vue&type=template&id=5b81927a&scoped=true&"
import script from "./TechKit.vue?vue&type=script&lang=js&"
export * from "./TechKit.vue?vue&type=script&lang=js&"
import style0 from "./TechKit.vue?vue&type=style&index=0&id=5b81927a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81927a",
  null
  
)

export default component.exports